function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M37.177 44.947C55.927 42.7 66.535 27.717 69 0H5a5 5 0 00-5 5v73c6.034-19.788 18.426-30.806 37.177-33.053z",
  opacity: 0.296
});

function SvgFilterButtonBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 78
  }, props), _ref);
}

export default SvgFilterButtonBg;